import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';


const GoogleAuthDone = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle, loginWithGoogleCode } = useAuth();
  const [processingAuth, setProcessingAuth] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [authProcessed, setAuthProcessed] = useState(false);

  // Gestion du Timeout de 15 secondes
  useEffect(() => {
  let timer: ReturnType<typeof setTimeout>;

  if (processingAuth) {
    timer = setTimeout(() => {
      setProcessingAuth(false);
      setError("Le délai d'attente est dépassé (15s). Le serveur ne répond pas, veuillez réessayer.");
      navigate('/login');
    }, 12000);
  }

  return () => clearTimeout(timer);
}, [processingAuth]);

  useEffect(() => {
    if (authProcessed) return;

    const searchParams = new URLSearchParams(location.search);
    const idToken = searchParams.get('id_token');
    const code = searchParams.get('code');
    
    window.history.replaceState({}, document.title, "/google-auth-done");

    const processAuth = async (token: string, type: 'id_token' | 'code') => {
      setAuthProcessed(true);

      try {
        console.log(`Processing ${type} authentication...`);
        if (type === 'id_token') {
          await loginWithGoogle(token);
        } else {
          console.log("Processing with code", token);
          await loginWithGoogleCode(token);
          navigate('/login');
        }
      } catch (err) {
        console.error("Authentication error:", err);
        setError("Une erreur s'est produite lors de l'authentification. Veuillez réessayer.");
        setProcessingAuth(false);
      }
    };

    if (idToken) {
      console.log("id_token found in URL:", idToken.substring(0, 10) + '...');
      processAuth(idToken, 'id_token');
    } else if (code) {
      console.log("code found in URL:", code.substring(0, 10) + '...');
      processAuth(code, 'code');
    } else {
      console.log("No authentication token found in URL");
      setProcessingAuth(false);
      setError("Aucun jeton d'authentification trouvé. Veuillez réessayer de vous connecter.");
    }

    try {
      if (window.opener && !window.opener.closed) {
        console.log("Attempting to close opener window");
        window.close();
      }
    } catch (e) {
      console.error("Error closing window:", e);
    }

  }, [navigate, location.search, loginWithGoogle, loginWithGoogleCode, authProcessed]);

  return (
    <div className="flex flex-col gap-4 items-center justify-center min-h-screen">
      {processingAuth ? (
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4" />
        </div>
      ) : error ? (
        <div className="text-red-500 font-semibold text-center px-4">
          <p>{error}</p>
          <button 
            className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 block mx-auto"
            onClick={() => navigate('/login')}
          >
            Retour à la page de connexion
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default GoogleAuthDone;